import { render, staticRenderFns } from "./ModalApproveContract.vue?vue&type=template&id=b73a50d4&scoped=true&"
import script from "./ModalApproveContract.vue?vue&type=script&lang=ts&"
export * from "./ModalApproveContract.vue?vue&type=script&lang=ts&"
import style0 from "./ModalApproveContract.vue?vue&type=style&index=0&id=b73a50d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73a50d4",
  null
  
)

export default component.exports